import { useTranslation } from 'react-i18next';
import {
  useAuthenticationConfirmationsResendEmailConfirmationMutation,
  useAuthenticationConfirmationsResendRegistrationConfirmationMutation,
} from '@lib/graphql-common';
import {
  useTeamUpdateMutation,
  useUserBulkActivateMutation,
  useUserBulkDeactivateMutation,
  useUserDestroyMutation,
  useUserUpdateMutation,
} from 'graphql-common';
import { getErrorMessage, showGraphQLErrors } from '@lib/utils/graphQLErrors';
import toast from '@lib/components/Toast/Toast';

export default function useUsersMutations() {
  const { t } = useTranslation();

  const [resendRegistrationConfirmationMutation] =
    useAuthenticationConfirmationsResendRegistrationConfirmationMutation({
      onCompleted: (response) => {
        const content =
          response?.data?.message || t('resend-confirmation-success');
        toast({ content });
      },
      onError: (error) => {
        toast({ content: getErrorMessage(error, t) });
      },
    });

  const [resendEmailConfirmationMutation] =
    useAuthenticationConfirmationsResendEmailConfirmationMutation({
      onCompleted: (response) => {
        const content =
          response?.data?.message || t('resend-confirmation-success');
        toast({ content });
      },
      onError: (error) => {
        toast({ content: getErrorMessage(error, t) });
      },
    });

  const [destroyMutation, destroyMutationResult] = useUserDestroyMutation({
    onError: (error) => {
      toast({ content: getErrorMessage(error, t) });
    },
  });

  const [bulkActivateMutation] = useUserBulkActivateMutation({
    onError: (error) => {
      toast({ content: getErrorMessage(error, t) });
    },
  });

  const [bulkDeactivateMutation] = useUserBulkDeactivateMutation({
    onError: (error) => {
      toast({ content: getErrorMessage(error, t) });
    },
  });

  const [teamUpdateMutation, teamUpdateMutationResult] = useTeamUpdateMutation({
    onError: (error) => showGraphQLErrors(error, t),
  });

  const [userUpdateMutation, userUpdateMutationResult] = useUserUpdateMutation({
    onError: (error) => {
      toast({ content: getErrorMessage(error, t) });
    },
  });

  return {
    bulkActivateMutation,
    bulkDeactivateMutation,
    destroyMutation,
    destroyMutationResult,
    resendEmailConfirmationMutation,
    resendRegistrationConfirmationMutation,
    teamUpdateMutation,
    teamUpdateMutationResult,
    userUpdateMutation,
    userUpdateMutationResult,
  };
}
